import { requiresAuth } from '../components/AuthProvider'

import Home from './Home'
import Login from './Login'
import OneHealthcareIdLogin from './OneHealthcareIdLogin'
import ActiveDirectoryLogin from './ActiveDirectoryLogin'
import LoginRedirect from './LoginRedirect'
import ActiveDirectoryLoginRedirect from './ActiveDirectoryLoginRedirect'
import SignOut from './SignOut'
import ActiveDirectorySignOut from './ActiveDirectorySignOut'
import Profile from './Profile'
import AccessAbort from './AccessAbort'
import NoAccess from './NoAccess'
import NotFound from './NotFound'
import Raredisease from './RareDisease/RarediseaseDetails'
import Dashboard from './Dashboard'
import Vulnerability from './Vulnerability/index'
import FluTabs from './Flu/FluTabs'
import FluDetails from './Flu/FluTabs/FluDetails'
import FluSurveillance from './Surveillance/FluSurveillance'
import HRRMap from './Forecasts/HRR'
import ForecastDashboard from './Forecasts/Home'
// import Feedback from './About/Feedback'
import AdminPages from './AdminPages'
import UsersPage from './AdminPages/Users'
import SystemNotificationsPage from './AdminPages/SystemNotifications'
import AddEditUser from './Admin/Users/AddEditUser'
import UserActivity from './Admin/UserActivity'
import Subscriptions from './Admin/Subscriptions/AddSubs'
import AddSubscription from './Admin/Subscriptions/AddEditSubscription'
import Emails from './Admin/Emails'
import Surveillance from './Surveillance/Home'
import AllergiesDashboard from './AllergiesDashboard'
import AllergiesStateDashboard from './AllergiesDashboard/AllergiesStateDashboard'
import AllergiesZip3Dashboard from './AllergiesDashboard/AllergiesZip3Dashboard'
import UserSubscription from './Subscriptions/ViewSubscription'
import AddSubscriptionUser from './Subscriptions/AddEditSubscription'
import PridictionDashboard from './DiseasePrediction/Dashboard'
import RiskCalculator from './RiskCalculator'
import CovidPharma from './CovidPharma'
import RSVDashboard from './RSVDashboard'
import UTIDashboardPOC from './UTIDashboardPOC'
import UtiDashboard from './UTIDashboard'
import UTIStateDashboard from './UTIDashboard/UTIStateDashboard'
import UTIMSADashboard from './UTIDashboard/UTIMSADashboard'
import UTIZip3Dashboard from './UTIDashboard/UTIZip3Dashboard'
import MeningitisDashboard from './Meningitis'
import VulnerabilityDashboard from './VulnerabilityDashboard'
import CovidStateDashboard from './CovidPharma/CovidStateDashboard'
import CovidGeoDashboard from './CovidPharma/CovidGeoDashboard'
import RSVStateDashboard from './RSVDashboard/RSVStateDashboard'
import RSVMSADashboard from './RSVDashboard/RSVGeoDashboard'
import FluStateDashboard from './Flu/FluStateDashboard'
import FluGeoDashboard from './Flu/FluGeoDashboard'
import FluZip3Dashboard from './Flu/FluZip3Dashboard'
import FluGeo from './Flu/FluTabs/FluMap/FluGeo'
import FluMeter from './FluMeter'
import HeatMap from './HeatMap'
import FluTrend from './FluTrend'
import AccuracyTrend from './AccuracyTrend'
import SeasonTrend from './SeasonTrend'
import FluVaccination from './FluVaccination'
import FluVaccinationDetails from './FluVaccinationDetails'
import Respiratory from './Surveillance/Respiratory'
import ModelTabs from './About/ModelTab'
import ViewProfile from '../pages/Subscriptions/ViewSubscription'
import ImageGenerate from './Dashboard/ImageGenerate'
import { FEEDBACK_LINK } from '../utils/constants'
import VulnerabilityStateDashboard from './VulnerabilityDashboard/VulnerabilityStateDashboard'
import VulnerabilityMSADashboard from './VulnerabilityDashboard/VulnerabilityMsaDashboard'
import RedirectExternalUsers from './ExternalUsers'
const adminAccounts = ['Admin']
const otherAccounts = ['Basic', 'Power User']
const specialAccounts = ['Special User']
const allAccounts = [...otherAccounts, ...adminAccounts, ...specialAccounts]
const phiPii = ['Admin', 'Power User']
const allEnvironments = ['local', 'stage', 'prod']

const Pages = [
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    component: Home,
    label: 'Home',
    path: '/',
    routes: [
      {
        isHidden: true,
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(Profile , { key : 'Profile'}),
        path: '/profile',
        routes: [],
      },
      {
        isHidden: true,
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(UserSubscription , { key : 'UserSubscription'}),
        label: 'Subscriptions',
        path: '/subscriptions',
        routes: [
          {
            authorizedRoles: adminAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(AddSubscriptionUser , { key : 'AddSubscriptionUser'}),
            label: 'Add Subscription',
            path: '/add',
          },
        ],
      },
      {
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(Dashboard , { key : 'Dashboard'}),
        label: 'Home',
        path: '/Home',
        routes: [],
      },
  
      // {
      //   authorizedRoles: allAccounts,
      //   envAccess: allEnvironments,
      //   component: requiresAuth(ImageGenerate),
      //   label: '',
      //   path: '/ImageGenerate',
      //   routes: [],
      // },
      {
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(ForecastDashboard , { key : 'ForecastDashboard'}),
        label: 'Forecasts',
        path: '/forecasts',
        routes: [                    
          {
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(Home , { key : 'Home'}),
            label: 'Home',
            path: '/Home',
            isHidden: false,
            routes: [],
          },
          {
            isHidden: false,
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(FluTabs , { key : 'FluTabs'}),
            label: 'Influenza level',
            path: '/Flumap',
            routes: [],
          },
          {
            isHidden: true,
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(FluDetails , { key : 'FluDetails'}),
            label: 'Flu Charts',
            path: 'flu/:area/:loc',
            routes: [],
          },
          
          { authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(CovidPharma , { key : 'CovidPharma'}),
            label: 'Covid Incidence',
            path: '/CovidDashboard',
            isHidden: false,
            routes: [],
          },
          { authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(RSVDashboard , { key : 'RSVDashboard'}),
            label: 'RSV Incidence',
            path: '/RSVDashboard',
            isHidden: false,
            routes: [],
          },
            { authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(UTIDashboardPOC , { key : 'UTIDashboardPOC'}),
            label: 'UTI Dashboard POC',
            path: '/utidashboardpoc',
            isHidden: true,
            routes: [],
          },
           { authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(UtiDashboard , { key : 'UTIDashboard'}),
            label: 'UTI Dashboard',
            path: '/utidashboard',
            isHidden: false,
            routes: [],
          },
           {
        isHidden: true,
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(UtiDashboard , { key : 'UTIDashboard' }),
        label: 'UtiStateDashboard',
        path: '/utistatedashboard',
        routes: [
          {
            isHidden: true,
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(UTIStateDashboard , { key : 'UTIDashboard' }),
            label: 'State View',
            path: ':area/:loc',
          },
        ],
      },   
      {
        isHidden: true,
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component:  requiresAuth(UtiDashboard , { key : 'UTIDashboard' }),
        label: 'UTIMSADashboard',
        path: '/utimsadashboard',
        routes: [
          {
            isHidden: true,
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(UTIMSADashboard , { key : 'UTIDashboard' }),
            label: 'MSA View',
            path: ':geo_parent/:area/:loc',
          },
        ],
      },   
      {
        isHidden: true,
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(UtiDashboard , { key : 'UTIDashboard' }),
        label: 'UTIZip3Dashboard',
        path: '/utizip3dashboard',
        routes: [
          {
            isHidden: true,
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(UTIZip3Dashboard , { key : 'UTIDashboard' }),
            label: 'Zip View',
            path: ':geo_parent/:area/:loc',
          },
        ],
      },
          { authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(MeningitisDashboard , { key : 'MeningitisDashboard'}),
            label: 'Meningitis',
            path: '/meningitisdashboard',
            isHidden: false,
            routes: [],
          },
          { authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(VulnerabilityDashboard , { key : 'VulnerabilityDashboard'}),
            label: 'Vulnerability',
            path: '/vulnerabilitydashboard',
            isHidden: false,
            routes: [],
          },
          { authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(AllergiesDashboard , { key : 'AllergiesDashboard'}),
            label: 'Allergies Dashboard',
            path: '/AllergiesDashboard',
            isHidden: false,
            routes: [],
          },

          {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      component: requiresAuth(RSVDashboard , { key : 'RSVDashboard'}),
      label: 'RSVDashboard',
      path: '/rsvstateDashboard',
      routes: [
        {
          isHidden: true,
          authorizedRoles: allAccounts,
          envAccess: allEnvironments,
          component: requiresAuth(RSVStateDashboard ,  { key : 'RSVStateDashboard'}),
          label: 'State View',
          path: ':area/:loc',
        },
      ],
    },
       {
        isHidden: true,
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(RSVDashboard , { key : 'RSVDashboard'}),
        label: 'RSVDashboard',
        path: '/RSVMSADashboard',

        routes: [
          {
            isHidden: true,
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(RSVMSADashboard , { key : 'RSVMSADashboard'}),
            label: 'MSA View',
            path: ':geo_parent/:area/:loc',
          },
        ],
      },
          { authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(VulnerabilityDashboard , { key : 'VulnerabilityDashboard'}),
            label: 'Vulnerability',
            path: '/vulnerabilitydashboard',
            isHidden: false,
            routes: [],
          },
          {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      component: requiresAuth(CovidPharma , { key : 'CovidPharma'}),
      label: 'covidDashboard',
      path: '/covidstateDashboard',
      routes: [
        {
          isHidden: true,
          authorizedRoles: allAccounts,
          envAccess: allEnvironments,
          component: requiresAuth(CovidStateDashboard , { key : 'CovidStateDashboard'}),
          label: 'State View',
          path: ':area/:loc',
        },
      ],
    },
    {
        isHidden: true,
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(CovidPharma , { key : 'CovidPharma'}),
        label: 'CovidDashboard',
        path: '/CovidMSADashboard',

        routes: [
          {
            isHidden: true,
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(CovidGeoDashboard , { key : 'CovidGeoDashboard'}),
            label: 'MSA View',
            path: ':geo_parent/:area/:loc',
          },
        ],
      },
      {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      component: requiresAuth(VulnerabilityDashboard , { key : 'VulnerabilityDashboard'}),
      label: 'VulnerabilityDashboard',
      path: '/vulnerabilitystatedashboard',
      routes: [
        {
          isHidden: true,
          authorizedRoles: allAccounts,
          envAccess: allEnvironments,
          component: requiresAuth(VulnerabilityStateDashboard , { key : 'VulnerabilityStateDashboard'}),
          label: 'State View',
          path: ':area/:loc',
        },
      ],
    },
    {
        isHidden: true,
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(VulnerabilityMSADashboard , { key : 'VulnerabilityMSADashboard'}),
        label: 'VulnerabilityMSADashboard',
        path: '/vulnerabilitymsadashboard',

        routes: [
          {
            isHidden: true,
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(VulnerabilityMSADashboard , { key : 'VulnerabilityMSADashboard'}),
            label: 'MSA View',
            path: ':geo_parent/:area/:loc',
          },
        ],
      },
          {
            isHidden: false,
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(HRRMap , { key : 'HRRMap'}),
            label: 'Covid-19 Weekly Hospitalization',
            path: '/hrrmap',
            routes: [],
          },

          
        ],
      },
      {
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(PridictionDashboard , { key : 'PridictionDashboard'}),
        label: 'Disease Prediction',
        path: '/DiseasePrediction',
        routes: [
          {
            envAccess: allEnvironments,
            authorizedRoles: phiPii,
            component: requiresAuth(PridictionDashboard, { roles : phiPii , key : 'PridictionDashboard' }),
            label: 'Home',
            path: '/home',
            routes: [],
          },
               
          // {
          //   isHidden: false,
          //   authorizedRoles: phiPii,
          //   envAccess: allEnvironments,
          //   component: requiresAuth(Vulnerability, phiPii), //Added to restrict vul
          //   label: 'Vulnerability',
          //   path: '/Vulnerability',
          //   routes: [],
          // },
          {
            isHidden: false,
            authorizedRoles: phiPii,
            envAccess: allEnvironments,
            component: requiresAuth(Raredisease, { roles : phiPii , key : 'Raredisease' }),
            label: 'Rare Disease',
            path: '/RareDisease',
            routes: [],
          },
          {
            isHidden: false,
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(RiskCalculator , { key : 'RiskCalculator' }),
            label: 'Cardiac Risk Calculator',
            path: '/RiskCalculator',
            routes: [],
          },
        ],
      },
      {
        authorizedRoles: adminAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(FluSurveillance, { roles : adminAccounts , key : 'FluSurveillance' }),
        label: 'Surveillance',
        path: '/Surveillance',

        routes: [
          // {
          //   authorizedRoles: allAccounts,
          //   envAccess: allEnvironments,
          //   component: requiresAuth(Surveillance),
          //   label: String.raw`Home`,
          //   path: '/Home',

          //   routes: [],
          // },
          {
            authorizedRoles: adminAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(FluSurveillance, { roles : adminAccounts , key : 'FluSurveillance' }),
            label: String.raw`Flu`,
            path: '/flu',

            routes: [],
          },
          {
            authorizedRoles: adminAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(Respiratory, { roles : adminAccounts , key : 'Respiratory' }),
            label: String.raw`Respiratory`,
            path: '/respiratory',

            routes: [],
          },
          {
            isHidden: true,
            authorizedRoles: adminAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(FluSurveillance, { roles : adminAccounts , key : 'FluSurveillance' }),
            path: '/covid',
            label: 'Covid-19',
            routes: [],
          },
          {
            isHidden: true,
            authorizedRoles: adminAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(FluSurveillance, { roles : adminAccounts , key : 'FluSurveillance' }),
            path: '/pasc',
            label: 'PASC',
            routes: [],
          },
        ],
      },
    
      {
        authorizedRoles: adminAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(FluVaccination, { roles : adminAccounts , key : 'FluVaccination' }),
        label: 'Vaccinations',
        path: '/Vaccinations',
      
        routes: [
          {
            isHidden: true,
            authorizedRoles: adminAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(FluVaccination, { roles : adminAccounts , key : 'FluVaccination' }),
           
            path: '/fluvaccination',
            routes: [],
          },
          {
            isHidden: true,
            authorizedRoles: adminAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(FluVaccinationDetails, { roles : adminAccounts , key : 'FluVaccinationDetails' }),
            label: 'Flu Vaccination Details',
            path: ':area',
          },
        ],
      },
      {
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(ModelTabs , { key : 'ModelTabs' }),
        label: 'About Models',
        path: '/about',
        
        routes: [
          {
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(ModelTabs , { key : 'ModelTabs' }),
            label: 'Model',
            path: '/model',
            isHidden: true,
            routes: [],
          },
          {
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(ModelTabs , { key : 'ModelTabs' }),
            label: String.raw`Model Information`,
            path: '/model#information',

            routes: [],
          },
          {
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(ModelTabs , { key : 'ModelTabs' }),
            label: String.raw`Model Accuracy`,
            path: '/model#accuracy',

            routes: [],
          },
//           {
//             authorizedRoles: allAccounts,
//             envAccess: allEnvironments,
//             component: Feedback,
//             externalLink: FEEDBACK_LINK,
//             isHidden: true,
//             path: '/feedback',
//             label: String.raw`Feedback & 
// Suggestions`,
//             new: false,
//             routes: [],
//           },
          {
            isHidden: true,
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(ViewProfile , { key : 'ViewProfile' }),
            label: 'ViewProfile',
            path: '/Viewprofile',

            routes: [],
          },
        ],
      },
      {
        authorizedRoles: adminAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(UsersPage, { roles : adminAccounts, key : 'UsersPage' }),
        label: 'Admin',
        path: '/admin',
        allowedRoles: adminAccounts,
        routes: [
          {
            isHidden: true,
            authorizedRoles: adminAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(Emails, { roles : adminAccounts, key : 'Emails' }),
            label: 'Emails',
            path: '/emails',
          },
          {
            authorizedRoles: adminAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(UsersPage , { roles : adminAccounts, key : 'UsersPage' }),
            label: 'Users',
            path: '/users',
            routes: [
              {
                authorizedRoles: adminAccounts,
                envAccess: allEnvironments,
                component: requiresAuth(AddEditUser, { roles : adminAccounts, key : 'AddEditUser' }),
                label: 'Add User',
                path: '/add',
              },
              {
                authorizedRoles: adminAccounts,
                envAccess: allEnvironments,
                component: requiresAuth(UsersPage, { roles : adminAccounts, key : 'UsersPage' }),
                label: 'View User',
                path: '/:id',
                routes: [
                  {
                    authorizedRoles: adminAccounts,
                    envAccess: allEnvironments,
                    component: requiresAuth(UsersPage, { roles : adminAccounts, key : 'UsersPage' }),
                    label: 'Edit User',
                    path: '/edit',
                  },
                ],
              },
            ],
          },
          {
            authorizedRoles: adminAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(SystemNotificationsPage, { roles : adminAccounts, key : 'SystemNotificationsPage' }),
            label: 'System Notifications',
            path: '/systemnotifications',
            routes: [
              {
                authorizedRoles: adminAccounts,
                envAccess: allEnvironments,
                component: requiresAuth(
                  SystemNotificationsPage, { roles : adminAccounts, key : 'SystemNotificationsPage' }),
                label: 'Add System Notifications',
                path: '/add',
              },
              {
                authorizedRoles: adminAccounts,
                envAccess: allEnvironments,
                component: requiresAuth(SystemNotificationsPage, { roles : adminAccounts, key : 'SystemNotificationsPage' }),
                label: 'View System Notifications',
                path: '/:id',
                routes: [
                  {
                    authorizedRoles: adminAccounts,
                    envAccess: allEnvironments,
                    component: requiresAuth(
                      SystemNotificationsPage, { roles : adminAccounts, key : 'SystemNotificationsPage' }),
                    label: 'Edit System Notifications',
                    path: '/edit',
                  },
                ],
              },
            ],
          },
          {
            authorizedRoles: adminAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(Subscriptions, { roles : adminAccounts, key : 'Subscriptions' }),
            label: 'Subscriptions',
            path: '/subscriptions',
            routes: [
              {
                authorizedRoles: adminAccounts,
                envAccess: allEnvironments,
                component: requiresAuth(AddSubscription, { roles : adminAccounts, key : 'AddSubscription' }),
                label: 'Add Subscription',
                path: '/add',
              },
            ],
          },
          {
            authorizedRoles: adminAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(UserActivity, { roles : adminAccounts, key : 'UserActivity' }),
            label: 'Users Activity',
            path: '/usersactivity',
          },
        ],
      },
      {
        authorizedRoles: adminAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(AdminPages, { roles : adminAccounts, key : 'AdminPages' }),
        label: 'AdminPages',
        path: '/adminpage',
        allowedRoles: adminAccounts,    
        isHidden: true,    
        routes: [
         
          {
            authorizedRoles: adminAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(UsersPage, { roles : adminAccounts, key : 'UsersPage' }),
            label: 'Users',
            path: '/users',
            routes: [
              {
                authorizedRoles: adminAccounts,
                envAccess: allEnvironments,
                component: requiresAuth(UsersPage, { roles : adminAccounts, key : 'UsersPage' }),
                label: 'Add User',
                path: '/add',
              },                            
              {
                authorizedRoles: adminAccounts,
                envAccess: allEnvironments,
                component:  requiresAuth(UsersPage, { roles : adminAccounts, key : 'UsersPage' }),
                label: 'View User',
                path: '/:id',
                routes: [
                  {
                    authorizedRoles: adminAccounts,
                    envAccess: allEnvironments,
                    component:  requiresAuth(UsersPage, { roles : adminAccounts, key : 'UsersPage' }),
                    label: 'Edit User',
                    path: '/edit',
                  },
                ],
              },
             
            
            ],
          },
          {
            authorizedRoles: adminAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(SystemNotificationsPage, { roles : adminAccounts, key : 'SystemNotificationsPage' }),
            label: 'System Notifications',
            path: '/systemnotifications',
            routes: [
              {
                authorizedRoles: adminAccounts,
                envAccess: allEnvironments,
                component: requiresAuth(SystemNotificationsPage, { roles : adminAccounts, key : 'SystemNotificationsPage' }),
                label: 'Add System Notifications',
                path: '/add',
              },
              {
                authorizedRoles: adminAccounts,
                envAccess: allEnvironments,
                component: requiresAuth(SystemNotificationsPage, { roles : adminAccounts, key : 'SystemNotificationsPage' }),
                label: 'View System Notifications',
                path: '/:id',
                routes: [
                  {
                    authorizedRoles: adminAccounts,
                    envAccess: allEnvironments,
                    component: requiresAuth(SystemNotificationsPage, { roles : adminAccounts, key : 'SystemNotificationsPage' }),
                    label: 'Edit System Notifications',
                    path: '/edit',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        isHidden: true,
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(FluGeo , { key : 'FluGeo' }),
        label: 'FluStateDashboard',
        path: '/FluStateDashboard',
        routes: [
          {
            isHidden: true,
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(FluStateDashboard , { key : 'FluStateDashboard' }),
            label: 'State View',
            path: ':area/:loc',
          },
        ],
      },   
      {
        isHidden: true,
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component:  requiresAuth(FluGeo , { key : 'FluGeo' }),
        label: 'FluMSADashboard',
        path: '/FluMSADashboard',
        routes: [
          {
            isHidden: true,
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(FluGeoDashboard , { key : 'FluGeoDashboard' }),
            label: 'MSA View',
            path: ':geo_parent/:area/:loc',
          },
        ],
      },   
      {
        isHidden: true,
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(FluGeo , { key : 'FluGeo' }),
        label: 'FluZip3Dashboard',
        path: '/FluZip3Dashboard',
        routes: [
          {
            isHidden: true,
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(FluZip3Dashboard , { key : 'FluZip3Dashboard' }),
            label: 'MSA View',
            path: ':geo_parent/:area/:loc',
          },
        ],
      },
      {
        isHidden: true,
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(CovidPharma , { key : 'CovidPharma' }),
        label: 'CovidDashboard',
        path: '/CovidStateDashboard',
        routes: [
          {
            isHidden: true,
            authorizedRoles: allAccounts,
            envAccess: allEnvironments,
            component: requiresAuth(CovidStateDashboard , { key : 'CovidStateDashboard' }),
            label: 'State View',
            path: ':area/:loc',
          },
        ],
      },
      {
        isHidden: true,
        authorizedRoles: allAccounts,
        envAccess: allEnvironments,
        component: requiresAuth(CovidPharma , { key : 'CovidPharma' }),
        label: 'CovidDashboard',
        path: '/CovidMSADashboard',

        routes: [
          {
            isHidden: true,
            authorizedRoles: allAccounts,
            envAccess: allEnvironments, 
            component: requiresAuth(CovidGeoDashboard , { key : 'CovidGeoDashboard' }),
            label: 'MSA View',
            path: ':geo_parent/:area/:loc',
          },
        ],
      },
      {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      // element: (
      //   <RequireAuth dashboardAccess={'allergiesdashboard'}>
      //     <AllergiesDashboard />
      //   </RequireAuth>
      // ),
      component: requiresAuth(AllergiesDashboard , { key : 'AllergiesDashboard' }),
      label: '',
      path: '/allergiesdashboard',
      dashboardAccess: 'allergiesdashboard',
      routes: [],
    },
    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      // element: (
      //   <RequireAuth dashboardAccess={'allergiesdashboard'}>
      //     <AllergiesDashboard />
      //   </RequireAuth>
      // ),
      component: requiresAuth(AllergiesDashboard , { key : 'AllergiesDashboard' }),
      label: 'allergiesdashboard',
      path: '/allergiesstatedashboard',
      dashboardAccess: 'allergiesdashboard',
      routes: [
        {
          isHidden: true,
          authorizedRoles: allAccounts,
          envAccess: allEnvironments,
          // element: (
          //   <RequireAuth dashboardAccess={'allergiesdashboard'}>
          //     <AllergiesStateDashboard />
          //   </RequireAuth>
          // ),
           component: requiresAuth(
            AllergiesStateDashboard,   { key : 'AllergiesStateDashboard' }),
          //   restrictAccounts          
          label: 'State View',
          path: ':area/:loc',
          dashboardAccess: 'allergiesdashboard',
        },
      ],
    },
    {
      isHidden: true,
      authorizedRoles: allAccounts,
      envAccess: allEnvironments,
      // element: (
      //   <RequireAuth dashboardAccess={'allergiesdashboard'}>
      //     <AllergiesZip3Dashboard />
      //   </RequireAuth>
      // ),
      component: requiresAuth(AllergiesZip3Dashboard ,  { key : 'AllergiesZip3Dashboard' }),
      label: 'allergieszip3dashboard',
      path: '/allergieszip3dashboard',
      dashboardAccess: 'allergiesdashboard',
      routes: [
        {
          isHidden: true,
          authorizedRoles: allAccounts,
          envAccess: allEnvironments,
          // element: (
          //   <RequireAuth dashboardAccess={'allergiesdashboard'}>
          //     <AllergiesZip3Dashboard />
          //   </RequireAuth>
          // ),
          component: requiresAuth(AllergiesZip3Dashboard ,  { key : 'AllergiesZip3Dashboard' }),
          label: 'MSA View',
          path: ':geo_parent/:area/:loc?',
          dashboardAccess: 'allergiesdashboard',
        },
      ],
    },
// UTI Dashboard 
     
    ],
  },  

  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    component: FluMeter,
    path: '/flumeter',
  },
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    component: HeatMap,
    path: '/heatmap',
  },
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    component: FluTrend,
    path: '/flutrend',
  },
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    component: AccuracyTrend,
    label: 'Flu Accuracy Comparison',
    path: 'AccuracyTrend/:area/:loc',
  },
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    component: SeasonTrend,
    label: 'Season Influenza Pattern',
    path: 'SeasonTrend/:area/:loc',

  },
 

  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    component: Login,
    path: '/login',
  },
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    component: OneHealthcareIdLogin,
    path: '/ohid-login',
  },
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    component: ActiveDirectoryLogin,
    path: '/ad-login',
  },
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    component: LoginRedirect,
    path: '/oauth2/login-redirect',
  },
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    component: ActiveDirectoryLoginRedirect,
    path: '/msid/login-redirect',
  },
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    component: SignOut,
    path: '/signout',
  },
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    component: ActiveDirectorySignOut,
    path: '/ad-signout',
  },
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    component: NoAccess,
    path: '/access-denied',
  },
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    component: AccessAbort,
    path: '/accessabort',
  },
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    component: RedirectExternalUsers,
    path: '/RedirectExternalUsers',
  },
  {
    authorizedRoles: allAccounts,
    envAccess: allEnvironments,
    component: NotFound,
    path: '*',
  },
]

export default Pages
